import jsPDF from 'jspdf';

export const generateBMIReport = (bmiResult, userData) => {
  const doc = new jsPDF();
  
  // Set up colors
  const primaryColor = [220, 38, 127]; // Pink
  const secondaryColor = [79, 70, 229]; // Indigo
  const textColor = [31, 41, 55]; // Gray-800
  const lightGray = [156, 163, 175]; // Gray-400
  
  // Header with branding
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, 210, 35, 'F');
  
  // Title
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('RUGGED FITNESS COACH SABARI', 15, 18);
  
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text('BMI & Fitness Report', 15, 28);
  
  // Date
  doc.setFontSize(9);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 145, 28);
  
  // Reset text color for body
  doc.setTextColor(...textColor);
  
  // Personal Information Section
  let yPosition = 50;
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('Personal Information', 15, yPosition);
  
  // Add underline
  doc.setDrawColor(...primaryColor);
  doc.setLineWidth(0.5);
  doc.line(15, yPosition + 2, 80, yPosition + 2);
  
  yPosition += 10;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  
  doc.text(`Weight: ${userData.weight} kg`, 15, yPosition);
  doc.text(`Height: ${userData.height} cm`, 65, yPosition);
  doc.text(`Age: ${userData.age} years`, 115, yPosition);
  doc.text(`Gender: ${userData.gender}`, 155, yPosition);
  
  yPosition += 7;
  doc.text(`Activity Level: ${getActivityLevelText(userData.activityLevel)}`, 15, yPosition);
  
  // BMI Results Section
  yPosition += 18;
  doc.setFillColor(...secondaryColor);
  doc.rect(10, yPosition - 4, 190, 26, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('BMI Analysis Results', 15, yPosition + 4);
  
  doc.setFontSize(10);
  doc.text(`BMI Category: ${bmiResult.category.text}`, 120, yPosition + 4);
  
  yPosition += 18;
  doc.setTextColor(...textColor);
  
  // BMI Score
  doc.setFontSize(28);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...primaryColor);
  doc.text(`${bmiResult.bmi}`, 15, yPosition);
  
  // Category color indicator
  const categoryColor = getCategoryColor(bmiResult.category.text);
  doc.setFillColor(...categoryColor);
  doc.rect(55, yPosition - 7, 35, 9, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.text(bmiResult.category.text, 57, yPosition - 1);
  
  // Detailed Metrics
  yPosition += 20;
  doc.setTextColor(...textColor);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('Detailed Health Metrics', 15, yPosition);
  
  doc.setDrawColor(...primaryColor);
  doc.line(15, yPosition + 2, 85, yPosition + 2);
  
  yPosition += 12;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  
  const metrics = [
    [`Ideal Weight:`, `${bmiResult.idealWeight.toFixed(1)} kg`],
    [`Weight Difference:`, `${bmiResult.weightDiff > 0 ? '+' : ''}${bmiResult.weightDiff} kg`],
    [`BMR (Base Metabolic Rate):`, `${bmiResult.bmr} calories/day`],
    [`Daily Calorie Needs:`, `${bmiResult.calories} calories/day`]
  ];
  
  doc.setFillColor(248, 250, 252);
  doc.rect(10, yPosition - 2, 190, metrics.length * 7 + 4, 'F');
  
  metrics.forEach(([label, value], index) => {
    const currentY = yPosition + (index * 7);
    doc.setFont('helvetica', 'normal');
    doc.text(label, 15, currentY);
    doc.setFont('helvetica', 'bold');
    doc.text(value, 120, currentY);
    
    if (index < metrics.length - 1) {
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.2);
      doc.line(15, currentY + 1.5, 195, currentY + 1.5);
    }
  });
  
  // Recommendations Section
  yPosition += metrics.length * 8 + 10;
  doc.setFillColor(248, 250, 252);
  doc.rect(10, yPosition - 3, 190, 35, 'F');
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...textColor);
  doc.text('Personalized Recommendations', 15, yPosition + 3);
  
  doc.setDrawColor(...primaryColor);
  doc.line(15, yPosition + 5, 100, yPosition + 5);
  
  yPosition += 10;
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  
  const recommendations = getRecommendations(bmiResult.category.text);
  recommendations.forEach((rec, index) => {
    if (index < 3) {
      doc.text(`• ${rec}`, 15, yPosition);
      yPosition += 4;
    }
  });
  
  // YouTube Channel Promotion
  yPosition += 6;
  doc.setFillColor(220, 38, 38);
  doc.rect(10, yPosition - 2, 190, 18, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.text('Transform Your Body with Rugged Fitness Coach Sabari!', 15, yPosition + 4);
  
  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.text('Subscribe: @Fitness_coach_129 | Rugged workouts • Power nutrition • Hardcore motivation', 15, yPosition + 10);
  
  // Footer
  yPosition += 22;
  const maxY = 270;
  if (yPosition > maxY - 20) {
    yPosition = maxY - 20;
  }
  
  doc.setFillColor(245, 245, 245);
  doc.rect(10, yPosition - 1, 190, 16, 'F');
  
  doc.setTextColor(...textColor);
  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.text('This report is generated by Rugged Fitness Coach Sabari BMI Calculator', 15, yPosition + 3);
  
  yPosition += 5;
  doc.text('YouTube: @Fitness_coach_129 | Developed by Sabarisan P', 15, yPosition + 3);
  
  yPosition += 5;
  doc.setFontSize(5);
  doc.setTextColor(...lightGray);
  doc.text('Disclaimer: This report is for informational purposes only. Consult a healthcare professional for medical advice.', 15, yPosition + 3);
  
  const fileName = `Rugged_Fitness_BMI_Report_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
};

const getActivityLevelText = (level) => {
  const levels = {
    sedentary: 'Sedentary (little/no exercise)',
    light: 'Light (light exercise 1-3 days/week)',
    moderate: 'Moderate (moderate exercise 3-5 days/week)',
    active: 'Active (hard exercise 6-7 days/week)',
    extra: 'Extra Active (very hard exercise, physical job)'
  };
  return levels[level] || level;
};

const getCategoryColor = (category) => {
  const colors = {
    'Underweight': [59, 130, 246],
    'Normal': [34, 197, 94],
    'Overweight': [251, 191, 36],
    'Obese': [239, 68, 68]
  };
  return colors[category] || [156, 163, 175];
};

const getRecommendations = (category) => {
  const recommendations = {
    'Underweight': [
      'Focus on strength training and muscle building exercises',
      'Increase caloric intake with nutrient-dense, healthy foods',
      'Consider protein supplements to support muscle growth'
    ],
    'Normal': [
      'Maintain current weight with a balanced, nutritious diet',
      'Combine cardiovascular exercise with strength training',
      'Focus on overall fitness, flexibility, and health'
    ],
    'Overweight': [
      'Create a moderate caloric deficit for gradual weight loss',
      'Increase cardiovascular exercises and daily activity',
      'Focus on whole foods and control portion sizes'
    ],
    'Obese': [
      'Create a sustainable caloric deficit for weight loss',
      'Start with low-impact exercises and gradually increase intensity',
      'Focus on whole, unprocessed foods and portion control'
    ]
  };
  return recommendations[category] || [];
};
